import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";

export default function LegalPage({ doc }) {
  return (
    <main className="bg-[#F8FAFC]">
      <Seo title={doc.seoTitle} description={doc.description} path={`/${doc.slug}`} />

      <section className="bg-white pb-10 pt-16 sm:pt-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <p className="font-mono text-xs font-semibold tracking-[0.22em] text-emerald-700">LEGAL</p>
          <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            {doc.title}
          </h1>
          <p className="mt-3 font-mono text-xs text-slate-400">Last updated: October 2026</p>
          <p className="mt-5 text-base leading-relaxed text-slate-600">{doc.intro}</p>
        </div>
      </section>

      <section className="py-12">
        <div className="mx-auto max-w-3xl space-y-6 px-5 lg:px-8" data-testid={`legal-${doc.slug}`}>
          {doc.sections.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i * 0.03, 0.2)}>
              <div className="rounded-2xl border border-slate-200 bg-white p-7">
                <h2 className="font-display text-lg font-bold text-slate-900">
                  {i + 1}. {s.h}
                </h2>
                {s.paras.map((p, j) => (
                  <p key={j} className="mt-3 text-sm leading-relaxed text-slate-600">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <div className="rounded-2xl bg-[#0D5C46] p-7 text-white">
              <h2 className="font-display text-lg font-bold">Questions about this policy?</h2>
              <p className="mt-2 text-sm leading-relaxed text-emerald-100/85">
                Email{" "}
                <a href="mailto:info@onecarelife.health" data-testid={`legal-contact-${doc.slug}`} className="font-semibold underline decoration-emerald-300 underline-offset-2">
                  info@onecarelife.health
                </a>
                , call +1 (775) 416-9317 or message us on WhatsApp at +91 85458 84773.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
